export interface UpsertTraderUserSettings {
    minTradeBalance: string;
    minTrustBalance: string;
    paymentMethodSettings: UpsertTraderPaymentMethodSetting[];
}

export interface UpsertTraderPaymentMethodSetting {
    paymentMethodId: number;
    dailyLimit: string;
    equalOrAboveThresholdCommissionRate: string;
    thresholdOrderAmount: string;
    upToThresholdCommissionRate: string;
}
